import 'datatables.net';

import $ from 'jquery';

import { xmlescape } from '#public/commons-global/common';

const FixAlreadyApplied = Symbol('useRestrictedHtmlDatatable');

type ColumnTypeEx = DataTables.ColumnLegacy & {
    //type is not converted to sType in this version
    type?: string;
    [FixAlreadyApplied]?: true;
};

//trying to fix html injection bug, monkeypatching datatables
//now column must specify explicitly if it allows html
function overrideColumn(column: DataTables.ColumnLegacy) {
    const _column: ColumnTypeEx = column;
    if(_column[FixAlreadyApplied]) {
        return;
    }
    const _fnGetData = column.fnGetData as (data: unknown, specific: string, ...rest: unknown[]) => unknown;
    column.fnGetData = function(data: unknown, type: string, ...rest: unknown[]) {
        const text = _fnGetData.call(column, data, type, ...rest);
        if(!text || (type != 'display')) {
            return text;
        }
        const columnType = _column.sType ?? _column.type;
        if(columnType !== 'html') {
            // eslint-disable-next-line @typescript-eslint/no-base-to-string
            return xmlescape(String(text));
        }
        return text;
    };
    _column[FixAlreadyApplied] = true;
}

export function useRestrictedHtmlDatatable(settings: DataTables.SettingsLegacy) {
    settings.aoColumns.forEach((c) => overrideColumn(c));
}

export function initRestrictedHtmlDatatable(table: HTMLElement | JQuery<HTMLElement>) {
    $(table).on('init.dt', (e, settings) => {
        useRestrictedHtmlDatatable(settings);
    });
}
